import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './SurfaceAITableLoading.scss';

const SurfaceAITableLoading = () => {
  const baseClassName = 'SurfaceAITableLoading';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__item`}>
        <div className={`${baseClassName}__item__logo`}>
          <LoadingShimmer shape="square" width="24px" height="30px" />
        </div>
        <div className={`${baseClassName}__item__name`}>
          <LoadingShimmer shape="rectangle" width="40%" height="16px" />
        </div>
      </div>
      <div className={`${baseClassName}__item`}>
        <div className={`${baseClassName}__item__logo`}>
          <LoadingShimmer shape="square" width="24px" height="30px" />
        </div>
        <div className={`${baseClassName}__item__name`}>
          <LoadingShimmer shape="rectangle" width="40%" height="16px" />
        </div>
      </div>
      <div className={`${baseClassName}__item`}>
        <div className={`${baseClassName}__item__logo`}>
          <LoadingShimmer shape="square" width="24px" height="30px" />
        </div>
        <div className={`${baseClassName}__item__name`}>
          <LoadingShimmer shape="rectangle" width="40%" height="16px" />
        </div>
      </div>
      <div className={`${baseClassName}__item`}>
        <div className={`${baseClassName}__item__logo`}>
          <LoadingShimmer shape="square" width="24px" height="30px" />
        </div>
        <div className={`${baseClassName}__item__name`}>
          <LoadingShimmer shape="rectangle" width="40%" height="16px" />
        </div>
      </div>
    </div>
  );
};

export default SurfaceAITableLoading;
